<style type="text/css">
  .h-timeline {
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 2em;
    color:#0A6287;
  }
  .p-timeline {
    border-left: solid 3px #eee;
    padding-left: 20px;
    margin-bottom: 40px;
  }
</style>



<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja"class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <span>Quem Somos</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="wrap-special-title">
        <div class="wrap-page-title">
            <h1 class="title">Quem Somos</h1>
        </div>
    </div> 

  <div class="container">

    <div class="aboutus-info style-center">
        <h2 class="title-aboutus">ALDO, LIDER EM SOLUÇÕES PARA GERAÇÃO DE ENERGIA SOLAR NO PAÍS!</h2>
      <p class="txt-content"></p>
    </div>

    <div class="row equal-container">
      <div >
        <div class="aboutus-box-score equal-elem ">
            <img class="aboutus-img" src="assets/images/logo-top-aldo-solar.png" alt="logo-aldo-solar" title="logo-aldo-solar">
        <!-- 	<span class="sub-title">Items in Store</span>-->
          <h3 class="desc">Aqui na Aldo temos devoção pelo que fazemos todos os dias. Em quase 40 anos, evoluímos e nos reinventamos. Muitas vezes. Na Kombi da Aldo, em cada janela um horizonte sonhado. No para-brisas, crescimento, evolução. No bagageiro cabe um sol. Afinal, temos o Astro-rei como parceiro. Somos destemidos. Nós jogamos de corpo e alma em todas as nossas crenças. Em nossas atitudes queremos refletir o brilho do sol. A luz que clareia e não ofusca. O calor que aquece e não exauri. Acreditamos na energia que o sol emana. Energia positiva. Sempre. O mercado de energia solar é muito mais que um segmento promissor que gera empregos, que impulsiona o país. É energia que não degrada, nem agride. Limpa, acessível, sustentável. Buscamos a sustentabilidade em seus vários aspectos. Só assim teremos futuro. Energia solar está no nosso GPS. É o nosso propósito, nosso destino, nossa partida e nossa chegada. E sob essa luz, queremos garantir que o sol nasça para todos os brasileiros. Verdadeiramente, entende? Nos orgulhamos muito de fazer parte dessa revolução e então nos dedicamos do nascer ao pôr do sol. Somos Crazy People... embarcados na Kombi da Aldo... e apaixonados pelo que fazemos.</h3>
        </div>      
      </div>
		</div>

    <div class="row">
        <div class="col-md-12">
            <h3 class="h-timeline">1982</h3>
            <p class="p-timeline">
                A Aldo Componentes Eletrônicos foi fundada em 1982 por Aldo Pereira Teixeira em Maringá, no Paraná. No início, a sede era na própria residência do fundador, que exercia o comércio de venda de “porta em porta”, viajando pelo estado em uma Kombi e levando às revendas e oficinas, peças para reposição no conserto de rádios e televisores.
            </p>
            <h3 class="h-timeline">1987</h3>
            <p class="p-timeline">
                A primeira edição da Revista “Loucuras do ALDO” é lançada.
                Com o passar dos anos e aumento de capital, a empresa aluga um prédio comercial de onde começou a despachar os produtos aos seus clientes. Em três anos adquiriu um imóvel de 400m2 e  comprou uma área de 8.000m2, construiu sua nova sede com 3.500m2 e, em seguida expandiu para 7.000m2.
            </p>
            <h3 class="h-timeline">1993</h3>
            <p class="p-timeline">
                Com foco em promover relacionamento entre a empresa e seus clientes, lançou o Clube Amigos do Aldo, que foi um gerador de conteúdo, informação e vínculo, que faz da Aldo, até hoje, uma empresa de distribuição com política forte e diferenciada.
            </p>
            <h3 class="h-timeline">1997</h3>
            <p class="p-timeline">
                Em março de 1997, o domínio www.aldo.com.br entra no ar e coloca a ALDO no cenário das empresas vanguardistas, que transformaram a internet e o e-commerce em uma ferramenta estratégica de negócios.
            </p>
            <h3 class="h-timeline">2001</h3>
            <p class="p-timeline">
                A ALDO conquista a Distribuição Autorizada Samsung, uma parceria que rendeu muitos benefícios para ambos e, por meio de campanhas como a “Samsung Solidária”, beneficiou entidades, revertendo verbas de ações promocionais na aquisição de agasalhos para crianças de instituições de apoio.
            </p>
            <h3 class="h-timeline">2002</h3>
            <p class="p-timeline">
                A ALDO torna-se Distribuidor Autorizado Intel®, dando o primeiro grande passo no cenário de TI.
            </p>
            <h3 class="h-timeline">2003</h3>
            <p class="p-timeline">
                A HP é uma empresa de tecnologia que opera em mais de 170 países e, em 2003 ampliou sua estratégia de atuação no mercado brasileiro com o anúncio de sua parceria com a ALDO, tornando-nos Distribuidor Autorizado.
            </p>
            <h3 class="h-timeline">2004</h3>
            <p class="p-timeline">
                A ALDO é nomeada pela Microsoft Brasil, Distribuidora Oficial das licenças OEM, OPEN e FPP.<br /><br />
                A ALDO International é fundada – Distribuição Autorizada para parceiros exclusivamente do território nacional, com o objetivo de abastecer OEMs e outros Distribuidores – frete CIF Brasil.
            </p>
            <h3 class="h-timeline">2007</h3>
            <p class="p-timeline">
                O Programa ALDO Crazy People é lançado.<br />
                É assim que, a partir de 1/4 de século, a Aldo congrega todas as suas ações e ferramentas ofertadas ao canal e conceitua seu comprometimento para mais de 25 anos de comportamento de sucesso nos negócios.
            </p>
            <h3 class="h-timeline">2009</h3>
            <p class="p-timeline">
                ALDO torna-se uma Indústria. Computadores, Desktops, PCs Gamer, NUCs, Ultratops, Servidores, Pen drives e muitos outros produtos passam a ser fabricados pela Aldo com foco na comercialização para as revendas e com ó benefício de se enquadrarem na Lei do PPB.<br />
                O PPB - Processo Produtivo Básico consiste no oferecimento de benefícios fiscais determinados por lei às empresas fabricantes que cumprirem requisitos estabelecidos pelo Ministério da Ciência e Tecnologia - MCT. A grande maioria dos estados também prevê incentivos fiscais de ICMS para produtos com PPB.
            </p>
            <h3 class="h-timeline">2010</h3>
            <p class="p-timeline">
                Aldo Pereira Teixeira é eleito “Executivo do ano”, no prêmio “Distribuidor Preferido”.<br />
                ALDO passa a figurar entre as 1.000 Maiores & Melhores empresas do Brasil no Ranking da Revista Exame.<br /><br />

                Neste mesmo ano a ALDO implantou a PLR - Participação nos Lucros e Resultados, uma ferramenta extremamente eficaz no acréscimo de motivação, que conduz os colaboradores a um maior comprometimento e gera uma melhor produtividade, propiciando uma forma de partilhar uma parcela dos lucros obtidos por ela com os seus funcionários.<br /><br />

                ALDO realiza rebranding da sua marca corporativa.<br />
                Uma nova identidade visual alinhada com uma companhia que tem os olhos para as próximas décadas foi criada acreditando no potencial do Brasil há quase 30 anos e vislumbrando um futuro verde-amarelo resolvemos incorporar o orgulho que sentimos em movimentar o país do futuro à nossa marca.
            </p>
            <h3 class="h-timeline">2011</h3>
            <p class="p-timeline">
                ALDO vence em 6 categorias no “Distribuidor Preferido”, entre elas, o “Distribuidor Preferido" do Brasil.
                No Ranking “Melhores e Maiores ”, da Exame, a Aldo se destaca no  quesito “liquidez corrente”, que significa a capacidade de pagamento no curto prazo, além de aparecer em outros itens na pesquisa que apontou as 1 mil empresas de maior destaque.<br /><br />

                Com objetivo de diminuir custos e facilitar a logística de seus produtos a ALDO abre uma filial em Vitória - ES.
            </p>
            <h3 class="h-timeline">2012</h3>
            <p class="p-timeline">
                Em atendimento às novas regras da Política Nacional de Resíduos Sólidos, a ALDO anuncia o lançamento nacional do projeto Aldo Crazy Recicla. Assim as revendas podem destinar vários componentes e eletrônicos em geral, onde será descaracterizado e reinserido na indústria como matéria-prima.<br /><br />
                Foi também lançado o serviço ALDO CRAZY MANAGER, uma ferramenta de loja virtual que está à disposição dos clientes da ALDO para ser adquirida e personalizada de acordo com as características de cada empresa.
            </p>
            <h3 class="h-timeline">2013</h3>
            <p class="p-timeline">
                A ALDO disponibiliza a seus clientes um serviço fantástico que se somará ao ALDO Crazy Manager: <b>CRAZY DROP SHIPPING</b>, ou mais conhecido como VENDA POR CONTA E ORDEM. Isto significa que uma mercadoria adquirida em um e-commerce ligado ao ALDO CRAZY MANAGER será entregue ao consumidor final.
                Pelos Correios, diretamente no endereço do cliente que comprou a mercadoria no e-commerce.<br /><br />
                A ALDO alcança uma grande conquista com as certificações ISO 14001, relacionada à gestão do meio ambiente, e OHSAS 18001, ligada à saúde e segurança ocupacional. A empresa, ainda renovou sua certificação de gestão de qualidade, por atender aos requisitos da norma ISO 9001:2008.
            </p>
            <h3 class="h-timeline">2014</h3>
            <p class="p-timeline">
                ALDO lança exclusivamente no mercado nacional, o menor desktop do mundo, o ULTRATOP NUC.
            </p>
            <h3 class="h-timeline">2015</h3>
            <p class="p-timeline">
                Aldo inicia no segmento de Energia Solar com o lançamento de Centrium Energy, trazendo ao canal, geradores de Energia Fotovoltaica.<br />
                Fecha contrato de distribuição no Brasil com a fabricante austríaca de Inversores Fronius.<br />
                Recebe o Prêmio Recicla E-Waste Brasil pela melhor logística reversa do mercado de TI em 2015.
            </p>
            <h3 class="h-timeline">2016</h3>
            <p class="p-timeline">
                Recebimento do Prêmio Inovação Intel 2015 América Latina com o NVR NUC Digifort como solução completa de segurança e vídeo-vigilância.<br />
                Aldo fecha parceria com o SENAI fornecendo e apoiando cursos de capacitação para instaladores de Geradores de Energia Fotovoltaica.
            </p>
            <h3 class="h-timeline">2017</h3>
            <p class="p-timeline">
                Completa 35 anos e reforça as ofertas no segmento de Energia Solar passando a vigorar como um dos principiais distribuidores no segmento.<br />
                Inicia o projeto Caravana Aldo Solar em dezenas de capitais levando capacitação e conhecimento sobre Energia Solar. <br />
                Fecha contratos com a  DJI, maior fabricante de drones civis do mundo e com importantes fabricantes do segmento fotovoltaico REFUSOL e BYD. <br />
                Aldo e Ecosolys patrocinam o tenista profissional André Sá.
            </p>
            <h3 class="h-timeline">2018</h3>
            <p class="p-timeline">
                Inauguração da nova sede da empresa, em Maringá/Pr, com infraestrutura de 23.000m² e 16.000m² de área construída.<br />
                Criação da garagem solar pública para abastecimento de carros elétricos na nova sede.<br />
                Aldo estreia na Intersolar, a maior feira do setor Solar da América Latina.<br />
                Aldo e ABB firmam parceria em prol da mobilidade elétrica no Brasil com a comercialização dos carregadores veiculares
            </p>
            <h3 class="h-timeline">2019</h3>
            <p class="p-timeline">
                Aldo encerra o seu melhor ano da história com 44.898 geradores vendidos (1 a cada 3 minutos). <br />
                Passa a figurar no Ranking do Jornal Valor Econômico entre as 1.000 maiores empresas do Brasil. <br />
                Fecha patrocínio com os tenistas profissionais Bruno Soares e Marcelo Demoliner. <br />
                Destina investimentos ao Hospital Pequeno Príncipe, maior centro de atendimento hospitalar infantil do Brasil.<br />
                Lança o novo Aldo 4.0 (www.aldo.com.br), seu portal de negócios, totalmente reformulado e responsivo.<br />
                Novos contratos de parcerias no setor solar e financeiro são fechados com Jinko Solar, Growatt, Dyness, K2 e Santander.
            </p>
            <h3 class="h-timeline">2020</h3>
            <p class="p-timeline">
                Fecha contrato com a PWC (Price Waterhouse Coopers) por 03 anos para auditoria de suas operações e demonstrações financeiras.<br />
                Lança novas famílias ON GRID, OFF GRID e ZERO GRID, totalizando mais de 12.000 modelos de geradores distintos e disponíveis no site.<br />
                Conquista o selo GPTW – Great Place to Work, de melhores empresas para trabalhar. <br />
                Enquanto o Brasil chega a 330 mil sistemas fotovoltaicos e 4 GW de potência instalada, Aldo alcança a marca histórica de 100.000 geradores comercializados. <br />
                1º lugar entre as melhores empresas do setor Comércio Atacadista e Exterior e 504ª maior empresa do Brasil segundo o Jornal Valor Econômico. <br />
                1º lugar entre as melhores empresas do setor Eletroeletrônico e 572ª maior empresa do Brasil segundo a Revista Exame.
            </p>
            <h3 class="h-timeline">2021</h3>
            <p class="p-timeline">
                Aldo é reconhecida pelo 2º ano com selo de melhores empresas para se trabalhar.<br />
                A ALDO alcança uma grande conquista com as certificações ISO 45001, relacionada à gestão de saúde e segurança ocupacional.<br />
            </p>
            <h3 class="h-timeline">2022</h3>
            <p class="p-timeline">
                Juliano Ohta ocupa o cargo de CEO da Aldo Solar.<br />
                Aldo Pereira Teixeira, fundador da Aldo Solar, permanece como advisor e mentor, além de ocupar uma cadeira com voto no Conselho Administrativo.<br />
                Aldo Solar completa 40 anos de fundação.<br />
            </p>
        </div>
    </div>

    <div class="our-team-info">
      <h4 class="title-box">35 anos se passaram</h4>
      <div class="our-staff">
        <carousel :number="4" :nav="false" :margin="20" :autoHeight="true" :autoWidth="true" :autoplayHoverPause="true">
          <div class="team-member equal-elem">
            <div class="media">
                <figure><img src="assets/images/1-aldo.jpg" alt="NANA"></figure>
            </div>
            <div class="info" style="width:270px;  word-wrap: normal">
              <b class="name">1982</b>
              <span class="title">Onde tudo começou</span>
              <p class="desc">A Aldo já nasceu inovando. No bagageiro de uma Kombi cabia toda a empresa e os sonhos do fundador Aldo Pereira Teixeira.</p>
            </div>
          </div>

          <div class="team-member equal-elem">
            <div class="media">
              <figure><img src="assets/images/2-aldo.jpg" alt="NANA"></figure>
            </div>
            <div class="info" style="width:270px;  word-wrap: normal">
              <b class="name">1982</b>
              <span class="title">A primeira garagem</span>
              <p class="desc">Ainda em 1982 a empresa passou a realizar seus serviços numa tradicional rua de comércio eletrônico de Maringá/PR</p>
            </div>
          </div>

          <div class="team-member equal-elem">
            <div class="media">
              <figure><img src="assets/images/4-aldo.jpg" alt="NANA"></figure>
            </div>
            <div class="info" style="width:270px;  word-wrap: normal">
              <b class="name">1990</b>
              <span class="title">Novo bagageiro</span>
              <p class="desc">E nova bagagem. Do conserto e venda de equipamentos de áudio, vídeo e som a Aldo deu seus primeiros passos para se tornar uma das principais distribuidores de TI do Brasil</p>
            </div>
          </div>

          <div class="team-member equal-elem">
            <div class="media">
              <figure><img src="assets/images/7-aldo.jpg" alt="NANA"></figure>
            </div>
            <div class="info" style="width:270px;  word-wrap: normal">
              <b class="name">2018</b>
              <span class="title">O bagageiro aumentou</span>
              <p class="desc">Aldo TI, Aldo Drone e Aldo Solar. Hoje a energia que vem do sol é a que move nosso crescimento e comprometimento com um planeta mais sustentável.</p>
            </div>
          </div>
        </carousel>
      </div>
     </div>
      
  </div>

  </main>
</template>
<script>

import Carousel from 'vue-owl-carousel'

export default {
name: "AboutUs",
  components: {
    Carousel
  },
};

</script>
